<template>
  <section id="survey">
    <div class="field">
      <div class="control">
        <label class="label">
          1. รู้จักกับ LINE Messaging API รึเปล่าเเละเคยใช้ LINE chatbot ไหม ถ้าเคย เคยใช้ของอะไร (ตัวอย่าง chatbot:
          SCBAM, LINE ดูดวง, Wongnai)
        </label>
        <textarea class="textarea" placeholder="ตอบคำถามข้อที่ 1" v-model="formData.lineBotKnowledge" required></textarea>
      </div>
    </div>
    <div class="field">
      <div class="control">
        <label class="label">
          2. น้องคิดว่า chatbot น่าจะทำอะไรได้บ้างและ ถ้าน้องมีโอกาสทำ chatbot ของตัวเองน้องอยากทำแชทบอทที่เอาไว้ทำอะไร
        </label>
        <textarea class="textarea" placeholder="ตอบคำถามข้อที่ 2" v-model="formData.lineBotOpinion"></textarea>
      </div>
    </div>
    <div class="field">
      <div class="control">
        <label class="label">
          3. ให้น้อง ๆ แต่งเรื่องโดยใช้คำเหล่านี้มาแต่ง พร้อมวาดภาพประกอบ (pm2.5 / แง๊นๆ / เลื่อน / ลวก / แอดดริ๊งค์ /
          หมี่หยก / Ask real / เพลิงนวล / เลือกตั้ง / ก็มาดิครับ)
        </label>
        <textarea class="textarea" placeholder="ตอบคำถามข้อที่ 3" rows="10" v-model="formData.storyContent"></textarea>
      </div>
    </div>
    <div class="level">
      <div class="level-item">
        <figure class="image is-256x256" v-if="storyImage !== null || formData.profilePhotoUrl !== null">
          <img :src="storyImage ? storyImage : formData.storyPhotoUrl" alt="Story Image" style="width: 256px; height: auto;">
        </figure>
      </div>
    </div>
    <div class="level">
      <div class="level-item">
        <div class="file">
          <label class="file-label">
            <input class="file-input" type="file" name="resume" @change="onFileChange">
            <span class="file-cta">
                <span class="file-icon">
                  <i class="fas fa-upload"></i>
                </span>
                <span class="file-label">
                Choose a file…
                </span>
              </span>
          </label>
        </div>
      </div>
    </div>
    <div class="field">
      <div class="control">
        <label class="label">
          4. แม่จ๋าช่วยหนูด้วย หนูกินกล้วยอยู่บนหลังคา ตกลงมาทายาหม่อง 20 กล่องก็ไม่หาย พี่อยากรู้ว่าทำไมทาตั้ง 20
          กล่องก็ยังไม่หายและต้องทำอย่างไรถึงจะหาย
        </label>
        <textarea class="textarea" placeholder="ตอบคำถามข้อที่ 4" v-model="formData.stupidQuestion"></textarea>
      </div>
    </div>
    <div class="field">
      <div class="control">
        <label class="label">
          5. น้อง ๆ คิดว่าตัวเองจะได้อะไรกลับไปบ้างหลังจากมาค่ายนี้
        </label>
        <textarea class="textarea" placeholder="ตอบคำถามข้อที่ 5" v-model="formData.expectation"></textarea>
      </div>
    </div>

    <div class="field">
      <div class="control">
        <label class="label">
          6. ให้น้อง Present ความเป็นตัวน้อง ว่าทำไมพี่ถึงต้องให้น้องมาเข้าค่ายนี้
        </label>
        <textarea class="textarea" placeholder="ตอบคำถามข้อที่ 6" v-model="formData.selfPresentation"></textarea>
      </div>
    </div>

    <div class="field">
      <div class="control">
        <label class="label">
          7. น้องเคยเข้าร่วมค่ายในโครงการอื่นบ้างหรือไม่ (ไม่รวมค่ายลูกเสือ-เนตรนารี จริยธรรมและค่าย ร.ด.)
          ถ้าเคยคือค่ายอะไร
        </label>
        <label class="radio">
          <input type="radio" name="wasParticipatedInCamp" v-model="formData.wasParticipatedInCamp" value="false">
          ไม่เคย
        </label>
        <label class="radio">
          <input type="radio" name="wasParticipatedInCamp" v-model="formData.wasParticipatedInCamp" value="true">
          เคย
        </label>
      </div>
      <div class="control" v-if="formData.wasParticipatedInCamp === 'true'">
        <label class="label">
          ค่ายที่น้องเคยเข้า
        </label>
        <input type="text" class="input" v-model="formData.participatedCamp">
      </div>
    </div>

    <div class="field">
      <div class="control">
        <label class="label">
          8. น้องทราบข่าวค่าย Hypercube 28 จากทางใด
        </label>
        <input class="input" placeholder="ตอบคำถามข้อที่ 8" v-model="formData.awarenessSource">
      </div>
    </div>

  </section>
</template>

<script>
    export default {
        name: "SurveyForm",
        data: function () {
            return {
                formData: {},
                storyImage: null
            }
        },
        methods: {
            onFileChange( e) {
                const files = e.target.files || e.dataTransfer.files;
                if (!files.length) return;
                this.createImage(files[0]);
                return this.$store.dispatch('setUserStoryPhoto', files[0]);
            },
            createImage(file) {
                let reader = new FileReader();
                reader.onload = (e) => {
                    this.storyImage = e.target.result;
                };
                reader.readAsDataURL(file);
            },
        },
        watch: {
            userFormDataState(newFormState) {
                this.formData = newFormState;
            },
            async formValue() {
                await this.$store.dispatch('setUserFormData', this.formData)
            }
        },
        computed: {
            formValue() {
                return Object.values(this.formData);
            },
            userFormDataState() {
                return this.$store.getters.userFormData;
            }
        }
    }
</script>

<style scoped>

</style>
